import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkMobileView = () => {
    setIsMobile(window.innerWidth <= 768); // You can adjust this value as needed
  };

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const openMenu = () => {
    const sidemenu = document.getElementById('sidemenu');
    sidemenu.style.right = '0';
  };

  const closeMenu = () => {
    const sidemenu = document.getElementById('sidemenu');
    sidemenu.style.right = '-200px';
  };

  return (
    <div id="header">
      <div className="container">
        <nav>
          <h1 style={{ fontSize: '200%' }}>
            <b style={{ color: '#ff004f' }}>S</b>
            <b>humaim.</b>
          </h1>
          
            <ul id="sidemenu">
            {isMobile && (
              <div style={{ display: 'flex', justifyContent: 'end', marginRight: '2rem' }}>
                <FontAwesomeIcon icon={faTimes} onClick={closeMenu} />
              </div>
              )}
              <li><a href="#header">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          
          {isMobile && (
            <FontAwesomeIcon icon={faBars} onClick={openMenu} />
          )}
        </nav>
        <div className="header-text">
          <p>Web Developer</p>
          <h1>Hi, I'm <span>Shumaim <br />Kiyani</span> from Pakistan</h1>
        </div>
      </div>
    </div>
  );
};

export default Header;
